import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FiCheck } from "react-icons/fi";
import siteConfig from "../config/siteConfig";
import "../css/paysuccess.css";

const PaySuccess = () => {
  const location = useLocation();
  const orderNumber = location.state?.orderNumber;
  const email = location.state?.email;

  if (!orderNumber) {
    return (
      <main className="success-page">
        <p className="eyebrow">Order status</p>
        <h1>No recent order found.</h1>
        <p className="success-message">
          Complete checkout to receive an order confirmation.
        </p>
        <div className="success-actions">
          <Link to="/shop" className="solid-button">
            Return to shop
          </Link>
        </div>
      </main>
    );
  }

  return (
    <main className="success-page">
      <div className="success-mark" aria-hidden="true">
        <FiCheck />
      </div>
      <p className="eyebrow">Order confirmed</p>
      <h1>Thank you for your order.</h1>
      <p className="success-message">
        Your selection is now being prepared with care.
        {email ? ` A confirmation has been prepared for ${email}.` : ""}
      </p>
      <dl>
        <div>
          <dt>Order number</dt>
          <dd>{orderNumber}</dd>
        </div>
        <div>
          <dt>Client service</dt>
          <dd>{siteConfig.contact.email}</dd>
        </div>
      </dl>
      <div className="success-actions">
        <Link to="/shop" className="solid-button">
          Continue shopping
        </Link>
        <Link to="/shipping" className="text-link">
          Delivery information
        </Link>
      </div>
    </main>
  );
};

export default PaySuccess;
